import { getToken, getLogin } from "../ressources/functions/helper";


export function WebSocketSetup() {

    let token = getToken();

    // let login_info = localStorage.getItem("login")
    let login_info = getLogin();

    if (token != null && token !== undefined && login_info !== undefined && login_info != null) {
        var loc = window.location, new_uri;

        if (loc.protocol.includes("https")) {
            new_uri = "wss:";
        } else {
            new_uri = "ws:";
        }

        new_uri += "//" + loc.host;
        new_uri += "/api/ws/?semabench-token=" + encodeURIComponent(token);

        const socket = new WebSocket(new_uri);
        socket.onopen = function (e) {
        };

        socket.onmessage = function (event) {
            try {
                let message = JSON.parse(event.data);
                if (message !== undefined && message !== null) {
                    if (message.t !== undefined && message.t !== null) {
                        if (message.t === "update_complete" && !window.location.href.includes("version")) {
                            window.location.replace("/logout?upgrade");
                        }
                    }
                }
            } catch (err) {
                console.error(err);
            }
        };

        // socket Handler if we loose connection from server
        socket.onclose = async function (event) {
            setTimeout(async () => {
                WebSocketSetup();
            }, 3000)
        };

        socket.onerror = function (event) {
            console.error("Error Connecting to Socket");
        }

    }

}
